import { ReactNode } from "react";

import { useT } from "src/internationalization";

import { WidgetDefinition, WidgetProperty } from "../Widgets/Widget.typings";

export function PrintableWidgetContainer({
  definition,
  children,
  pageBreakBefore,
}: {
  definition: WidgetDefinition;
  children: ReactNode;
  pageBreakBefore?: boolean;
}) {
  return (
    <section
      className={`printable-widget mt-5 h-auto overflow-visible  ${
        pageBreakBefore ? " printable-break-before" : ""
      }`}
      data-widget-code={definition.code}
    >
      <h2 className="text-heading02 font-heading02 border-b-2 border-solid border-b-borderInverse pb-3 mb-3">
        {definition.title}
      </h2>
      {definition.description && (
        <p className="printable-description text-textSecondary mb-2">{definition.description}</p>
      )}
      {children}
    </section>
  );
}

export function PrintableProperties({
  properties,
  keepTogether = false,
}: {
  properties: WidgetProperty[];
  keepTogether?: boolean;
}) {
  const t = useT();
  return (
    <dl className={`pdf-properties m-0  ${keepTogether ? " printable-keep-together" : ""}`}>
      {properties.map((property, index) => (
        <div
          className="grid grid-cols-[40%_1fr] gap-4 border-b border-solid py-3 border-b-borderSubtle max-[760px]:gap-[2px]  max-[760px]:grid-cols-1 "
          key={`${property.code ?? "property"}-${index}`}
        >
          <dt className="text-label02 text-textSecondary">{property.label}</dt>
          <dd className="text-label02 m-0">
            {property.value === null || property.value === undefined || property.value === ""
              ? "—"
              : property.value}
            {property.blacklist && (
              <p className="printable-flag text-supportError text-label01 mt-1">
                {t("page.alert.pdf.blacklist.list")} : {property.blacklist}
              </p>
            )}
            {property.mismatch && (
              <p className="printable-flag text-supportError text-label01 mt-1">
                {t("page.alert.pdf.blacklist.gap")} ·{" "}
                {t("page.alert.pdf.blacklist.comparison.value")} : {property.comparisonValue ?? "—"}
              </p>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
